import { makeStyles } from '@material-ui/core/styles';
import variables from 'static/styles/jss/abstracts/variables';
import { MediaQuery } from 'static/styles/jss/abstracts/mixins';

export default makeStyles({
  'points-container': {
    backgroundColor: variables.$contentBlueColor,
    padding: '20px',
    borderRadius: '4px',
    marginBottom: '16px',
    ...MediaQuery.up({
      position: 'sticky',
      top: '100px',
    }).sm,
    '& p': {
      cursor: 'pointer',
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
});
